/**
 * Token storage helpers — localStorage key `token` (cùng key với authSlice
 * để apiSlice và baseApi chia sẻ 1 token duy nhất sau login).
 * Component KHÔNG đọc localStorage trực tiếp, luôn qua các hàm này.
 */

const TOKEN_KEY = 'token'
const EXPIRY_KEY = 'token_expires_at'

export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function setStoredToken(token: string | null): void {
  try {
    if (token === null) {
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(EXPIRY_KEY)
    } else {
      localStorage.setItem(TOKEN_KEY, token)
    }
  } catch {
    /* ignore quota errors */
  }
}

export function getStoredExpiry(): string | null {
  try {
    return localStorage.getItem(EXPIRY_KEY)
  } catch {
    return null
  }
}

export function setStoredExpiry(expiresAt: string | null): void {
  try {
    if (expiresAt === null) localStorage.removeItem(EXPIRY_KEY)
    else localStorage.setItem(EXPIRY_KEY, expiresAt)
  } catch {
    /* ignore */
  }
}

/** Compatible alias names (in case other modules look for these). */
export const getAuthToken = getStoredToken
export const setAuthToken = setStoredToken
export const getAuthExpiry = getStoredExpiry

export function isExpired(expiresAt?: string | null): boolean {
  const exp = expiresAt ?? getStoredExpiry()
  if (!exp) return false
  const t = Date.parse(exp)
  if (Number.isNaN(t)) return false
  return Date.now() >= t
}
